const getAiConclusions = {
  status: 200,
  data: {
    recommendations: ['This is ai generated language - suggestion 1', 'This is ai generated language - suggestion 2'],
  },
}

export default getAiConclusions
